import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "./NavigationMenu.module.scss";

const navLinks = [
  { label: "Companion Brief", sectionId: "companion-brief" },
  { label: "The Problem", sectionId: "pain-point" },
  { label: "What Vertik Is", sectionId: "what-vertik-is" },
  { label: "How It Works", sectionId: "how-it-works" },
  { label: "Capabilities", sectionId: "capabilities" },
  { label: "The Product", sectionId: "the-product" },
  { label: "A Day with Vertik", sectionId: "day-with-vertik" },
  { label: "What You Get", sectionId: "what-you-get" },
  { label: "About Us", sectionId: "about" },
  { label: "FAQ", sectionId: "faq" },
  { label: "Contact", sectionId: "contact" },
];

const midpoint = Math.ceil(navLinks.length / 2);
const leftColumnLinks = navLinks.slice(0, midpoint);
const rightColumnLinks = navLinks.slice(midpoint);

const NavigationMenu = ({ setIsMenuOpen, onLogoClick }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const navigateToSection = (sectionId) => {
    setIsMenuOpen(false);

    if (location.pathname === "/") {
      const section = document.querySelector(`#${sectionId}`);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate("/", { state: { scrollTo: sectionId } });
    }
  };

  return (
    <div className={styles.menuContainer}>
      <div className={styles.leftBox}>
        <img
          src="/vertik-logo-name.png"
          className={styles.logoText}
          alt="Vertik AI"
          onClick={onLogoClick}
        />
        <div className={styles.navLinksGrid}>
          <div className={styles.navColumn}>
            {leftColumnLinks.map((link) => (
              <p
                key={link.sectionId}
                onClick={() => navigateToSection(link.sectionId)}
              >
                {link.label}
              </p>
            ))}
          </div>
          <div className={styles.navColumn}>
            {rightColumnLinks.map((link) => (
              <p
                key={link.sectionId}
                onClick={() => navigateToSection(link.sectionId)}
              >
                {link.label}
              </p>
            ))}
          </div>
        </div>
      </div>

      <div className={styles.rightBox}>
        <button
          type="button"
          className={styles.bookACallBtn}
          onClick={() => navigateToSection("contact")}
        >
          Book a Call
        </button>

        <div className={styles.socialLinks}>
          <div className={styles.socialIcon}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="23"
              height="22"
              viewBox="0 0 23 22"
              fill="none"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.17227 3H2.5L9.22535 11.701L2.93022 19H5.83876L10.6 13.4795L14.8277 18.9493H20.5L13.5793 9.99546L13.5915 10.0109L19.5504 3.10164H16.6418L12.2167 8.23256L8.17227 3ZM5.631 4.52382H7.39685L17.369 17.4254H15.6032L5.631 4.52382Z"
                fill="white"
              />
            </svg>
          </div>

          <div className={styles.socialIcon}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="23"
              height="22"
              viewBox="0 0 23 22"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M16.8257 19H6.17433C4.70246 19 3.5 17.7975 3.5 16.3257V5.67433C3.5 4.20246 4.70246 3 6.17433 3H16.8257C18.2975 3 19.5 4.20246 19.5 5.67433V16.3257C19.5 17.8041 18.3041 19 16.8257 19Z"
                fill="white"
              />
              <path
                d="M11.5033 15.1105C10.4059 15.1105 9.37431 14.6834 8.59895 13.9081C7.82359 13.1327 7.39648 12.1011 7.39648 11.0037C7.39648 9.90642 7.82359 8.8748 8.59895 8.09944C9.37431 7.32408 10.4059 6.89697 11.5033 6.89697C12.6006 6.89697 13.6322 7.32408 14.4076 8.09944C15.1829 8.8748 15.61 9.90642 15.61 11.0037C15.61 12.1011 15.1829 13.1327 14.4076 13.9081C13.6256 14.6834 12.6006 15.1105 11.5033 15.1105ZM11.5033 7.77089C9.72256 7.77089 8.27041 9.21648 8.27041 11.0037C8.27041 12.7844 9.71599 14.2366 11.5033 14.2366C13.284 14.2366 14.7361 12.791 14.7361 11.0037C14.7295 9.22305 13.284 7.77089 11.5033 7.77089Z"
                fill="#7584D6"
              />
              <path
                d="M16.4106 6.76161C16.8461 6.76161 17.1991 6.40858 17.1991 5.97309C17.1991 5.5376 16.8461 5.18457 16.4106 5.18457C15.9751 5.18457 15.6221 5.5376 15.6221 5.97309C15.6221 6.40858 15.9751 6.76161 16.4106 6.76161Z"
                fill="#7584D6"
              />
            </svg>
          </div>

          <div className={styles.socialIcon}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="23"
              height="22"
              viewBox="0 0 23 22"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M7.11203 8.26123H3.76855V18.9234H7.11203V8.26123Z"
                fill="white"
              />
              <path
                d="M16.1568 8.02975C16.0335 8.01434 15.9025 8.00664 15.7716 7.99893C13.8995 7.9219 12.8441 9.03125 12.4743 9.50889C12.3742 9.63986 12.328 9.71689 12.328 9.71689V8.29168H9.13086V18.9538H12.328H12.4743C12.4743 17.8676 12.4743 16.789 12.4743 15.7028C12.4743 15.1173 12.4743 14.5318 12.4743 13.9463C12.4743 13.2222 12.4204 12.4518 12.7825 11.7892C13.0906 11.2346 13.6453 10.9572 14.2693 10.9572C16.1183 10.9572 16.1568 12.629 16.1568 12.783C16.1568 12.7907 16.1568 12.7984 16.1568 12.7984V19H19.5003V12.0435C19.5003 9.66297 18.2907 8.26087 16.1568 8.02975Z"
                fill="white"
              />
              <path
                d="M5.44039 6.88226C6.51258 6.88226 7.38177 6.01307 7.38177 4.94088C7.38177 3.86869 6.51258 2.99951 5.44039 2.99951C4.3682 2.99951 3.49902 3.86869 3.49902 4.94088C3.49902 6.01307 4.3682 6.88226 5.44039 6.88226Z"
                fill="white"
              />
            </svg>
          </div>

          <div className={styles.socialIcon}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="23"
              height="22"
              viewBox="0 0 23 22"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M14.7788 3.60865L14.3927 3H12.0567V8.48185L12.0487 13.8364C12.0527 13.8762 12.0567 13.9199 12.0567 13.9597C12.0567 15.3003 10.9663 16.3943 9.62115 16.3943C8.27603 16.3943 7.18561 15.3043 7.18561 13.9597C7.18561 12.6191 8.27603 11.5251 9.62115 11.5251C9.89972 11.5251 10.1703 11.5768 10.4211 11.6643V8.99105C10.1624 8.94729 9.89574 8.92342 9.62115 8.92342C6.84735 8.9274 4.58691 11.187 4.58691 13.9637C4.58691 16.7404 6.84735 19 9.62513 19C12.4029 19 14.6633 16.7404 14.6633 13.9637V7.59473C15.6702 8.60119 16.9715 9.58379 18.4122 9.89806V7.16509C16.8482 6.4729 15.2921 4.42815 14.7788 3.60865Z"
                fill="white"
              />
            </svg>
          </div>

          <div className={styles.socialIcon}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="23"
              height="22"
              viewBox="0 0 23 22"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M17.5672 17.0673H5.43192C3.80819 17.0673 2.5 15.6313 2.5 13.865V8.13539C2.5 6.36193 3.81477 4.93311 5.43192 4.93311H17.5672C19.1909 4.93311 20.4991 6.36911 20.4991 8.13539V13.865C20.5057 15.6385 19.1909 17.0673 17.5672 17.0673Z"
                fill="white"
              />
              <path
                d="M14.6831 10.9101L9.57812 7.96631V13.8539L14.6831 10.9101Z"
                fill="#7584D6"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavigationMenu;
